import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { DialogModal } from './common/DialogModal';
import {DropDown} from '../../components/shared/Elements';
import {
  saveUnofficialResult,
  getUnofficialResults,
  removeUnofficialResult
} from '../../data/UnofficialResultsStream';
import { getResultsUrl } from '../../utils/resultsHelpers';

const modalStyles = {
  subTitle: {
    color: '#888888',
    fontFamily: 'ProximaNovaRegular',
    fontSize: 14,
    lineHeight: '17px'
  }
};

class UnofficialResultsComponent extends Component {

  static propTypes = {
    athleteList: PropTypes.object,
    options: PropTypes.array,
    t: PropTypes.func
  };

  state = {
    UnofficialTime: '00:00:00',
    resultLink: '',
    SelectedCourseId: 0,
    hasPickedCourse: false,
    success: true
  };

  componentDidMount(){
    const { athleteList, options } = this.props;
    const onlyOneOption = options && options.length === 1;

    const selectedCourse = onlyOneOption
      ? options[0].value
      : athleteList && athleteList.CourseID;

    this.setState({
      SelectedCourseId: selectedCourse,
      UnofficialTime: athleteList && athleteList.UnofficialTime,
      hasPickedCourse: !!selectedCourse
    })
  }

  async addUnofficial() {
    const { hasPickedCourse, SelectedCourseId } = this.state;
    const { races, mode, history } = this.props;
    if (!hasPickedCourse) {
      return;
    }
    const data = this.state;
    const saveUnofficialResultStream = await saveUnofficialResult(this.props.eventId, data);
    return saveUnofficialResultStream.subscribe(() => {
      getUnofficialResults(this.props.eventId);
      if (!!races.races.length && mode === 'addNew') {
        const changedRace = races.races.find((race) => race.courseId === SelectedCourseId);
        if (changedRace) {
          const { masterId, eventId, eventCourseId } = changedRace;
          const redirectUrl = getResultsUrl(masterId, eventId, eventCourseId);
          history.push(redirectUrl);
        }
      }
      this.props.handleClose();
    });
  };

  setTime = (e) => {
    const time = e.target.value;
    this.setState({UnofficialTime: time});
  };


  formatTime(time){
    if (time.length === 5) {
      return '00:' + time
    } else {
      return time;
    }
  }

  setResultLink = (e) => {
    const resultLink = e.target.value;
    this.setState({Url: resultLink});
  };

  onChange = (x) => {
    this.setState({SelectedCourseId: x, hasPickedCourse: true});
  };

  getBody() {
    const {
      options,
      t
    } = this.props;

    const courseDisabled = this.props.mode === 'edit';

    return (
      <div>
        <div style={modalStyles.subTitle}>
          {t('This will be an unoffical result and will not be used to '
            + 'calculate your PRs. Once official results are available, this result '
            + 'will be replaced by an official result.')}
        </div>
        <div style={{ width: '35%'}}>
          <DropDown
            id='courses'
            onChange={this.onChange}
            disabled={courseDisabled}
            value={this.props.athleteList ?
              this.props.athleteList.CourseID : this.state.SelectedCourseId
            }
            label={t('Course Required')}
            options={options ? options : []}/>
        </div>
        <div>
          {/*<TextField*/}
          {/*  defaultValue={this.props.athleteList ? this.formatTime(this.props.athleteList.UnofficialTime) : '00:00:00'}*/}
          {/*  floatingLabelFixed={true}*/}
          {/*  fullWidth={true}*/}
          {/*  underlineStyle={{color: '#4a4a4a', backgroundColor: '#4a4a4a'}}*/}
          {/*  underlineFocusStyle={{borderColor: '#4a4a4a'}}*/}
          {/*  floatingLabelFocusStyle={{color: '#4a4a4a'}}*/}
          {/*  floatingLabelText={t('Your time')}*/}
          {/*  onKeyUp={this.setTime}*/}
          {/*/>*/}
        </div>
        <div>
          {/*<TextField*/}
          {/*  defaultValue=""*/}
          {/*  fullWidth={true}*/}
          {/*  underlineStyle={{color: '#4a4a4a', backgroundColor: '#4a4a4a'}}*/}
          {/*  underlineFocusStyle={{borderColor: '#4a4a4a'}}*/}
          {/*  floatingLabelFocusStyle={{color: '#4a4a4a'}}*/}
          {/*  floatingLabelFixed={true}*/}
          {/*  onKeyUp={this.setResultLink}*/}
          {/*  floatingLabelText={t('Results Link (Optional)')}*/}
          {/*/>*/}
        </div>
      </div>
    );
  }


  getActions() {
    const {
      t
    } = this.props;
    const { success, hasPickedCourse } = this.state;
    const closeCallback = success ? this.addUnofficial.bind(this) : this.props.handleClose;

    const modalButton = {
      minWidth: 100,
      height: 40,
      color: '#fff',
      backgroundColor: hasPickedCourse ? '#16A9E1' : 'f4f4f4',
      border: hasPickedCourse ? '2px solid #16A9E1' : '2px solid #f4f4f4',
      paddingBottom: 15,
      fontSize: 20,
      textTransform: 'normal',
      fontFamily: 'ProximaNovaRegular',
      paddingLeft: 50,
      paddingRight: 50
    } ;
    const actionButtonContainer = {
      textAlign: 'left',
      padding: '20px 40px 40px 40px'
    };

    const modalButtonClose = {
      minWidth: 100,
      height: 40,
      textTransform: 'capitalize',
      margin: '0px 20px 0px 0px',
      width: 180,
      color: '#414141',
      backgroundColor: '#fff',
      paddingBottom: 10,
      fontSize: 17,
      marginRight: 6
    };

    return (
        <div style={actionButtonContainer}>
          { this.props.athleteList &&
          <div style={{float: 'left'}}>
            {/*<FlatButton*/}
            {/*  backgroundColor='#009fb7'*/}
            {/*  hoverColor='#00B5D0'*/}
            {/*  style={{...modalButtonClose, width: 230}}*/}
            {/*  label={t('Remove my unofficial time')}*/}
            {/*  primary={true}*/}
            {/*  onTouchTap={this.removeFromUnofficialResults.bind(this)}/>*/}
          </div>
          }
          <div style={{textAlign: 'right'}}>
            {/*<FlatButton*/}
            {/*  backgroundColor='#fff'*/}
            {/*  hoverColor='#D0477D'*/}
            {/*  style={modalButton}*/}
            {/*  label={t('Save My Time')}*/}
            {/*  primary={true}*/}
            {/*  onTouchTap={closeCallback}/>*/}
          </div>
        </div>
    );
  }

  render() {
    const {
      t
    } = this.props;

    const modalH1 = {  
      fontSize: 25,
      float: 'left',
      width: '100%',
      color: '#4a4a4a',
      fontFamily: 'ProximaNovaRegular'  
    };

    return (
      <DialogModal
        isMobile={this.props.isMobile}
        title={<h1 style={modalH1} id='add-edit-time'>
          {t('Add/Edit Your Unofficial Time')}
          </h1>}
        body={this.getBody()}
        actions={this.getActions()}
        open={this.props.open}
        saveUnofficialResult={this.addUnofficial}
        onRequestClose={this.props.handleClose}
        bodyStyle={{minHeight: 120}}/>
    );
  }

  removeFromUnofficialResults = async () => {
    const removeUnofficialResultStream = await removeUnofficialResult(this.props.eventId);
    return removeUnofficialResultStream.subscribe(() => {
      getUnofficialResults(this.props.eventId);
      this.props.handleClose();
    });
  }
}

export const UnofficialResults = withTranslation()(withRouter(UnofficialResultsComponent));



/** WEBPACK FOOTER **
 ** ./components/modal/UnofficialResults.js
 **/